<template>
  <PlainStoryEditor
    v-model="value"
    :height="getOptionValue(LayoutHeight)"
    :max-height="getOptionValue(MaxHeight)"
    :max-width="getOptionValue(MaxWidth)"
    :min-height="getOptionValue(MinHeight)"
    :min-width="getOptionValue(MinWidth)"
    :preview="!isEditable"
    :publication-id="useFanPublicationStore().publicationId"
    :use-border="isEditable"
    :width="getOptionValue(LayoutWidth)"
  />
</template>

<script>
import { DynamicElementMixin } from "%/dynamic-components/render-engine/mixins/production/dynamic-element-mixin";
import DynamicElementWithContext from "%/dynamic-components/render-engine/mixins/production/dynamic-element-with-context-mixin";
import PlainStoryEditor from "%/components/PlainStoryEditor.vue";
import useFanPublicationStore from "%/stores/fan-publication-store";
import LayoutWidth from "%/dynamic-components/render-engine/options/layout-options/layout-width";
import LayoutHeight from "%/dynamic-components/render-engine/options/layout-options/layout-height";
import MinHeight from "%/dynamic-components/render-engine/options/spacing-options/min-height";
import MinWidth from "%/dynamic-components/render-engine/options/spacing-options/min-width";
import MaxHeight from "%/dynamic-components/render-engine/options/spacing-options/max-height";
import MaxWidth from "%/dynamic-components/render-engine/options/spacing-options/max-width";
import LayoutWidthHeightOptions from "%/dynamic-components/render-engine/bundles/layout-width-height-options";

export default {
  name: "DynamicAppStoryElement",
  components: { PlainStoryEditor },
  mixins: [DynamicElementMixin, DynamicElementWithContext],
  elementPanelSettings: {
    displayName: "Text",
    elementGroup: "general",
    displayIcon: "text",
    elementType: "element",
  },
  hidden: true,
  optionBundles: [
    new LayoutWidthHeightOptions({
      "default.min-height": 100,
    }),
  ],
  computed: {
    MaxWidth() {
      return MaxWidth;
    },
    MaxHeight() {
      return MaxHeight;
    },
    MinWidth() {
      return MinWidth;
    },
    MinHeight() {
      return MinHeight;
    },
    LayoutHeight() {
      return LayoutHeight;
    },
    LayoutWidth() {
      return LayoutWidth;
    },
    isEditable() {
      return false;
    },
    value() {
      try {
        return JSON.parse(this.valueFromContext);
      } catch (e) {
        if (Array.isArray(this.valueFromContext)) {
          return this.valueFromContext;
        }
        return [];
      }
    },
  },
  methods: {
    useFanPublicationStore,
  },
};
</script>
